module.exports = __webpack_public_path__ + "img/baojing_checked.6f7736da.png";